import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  margin-top: 40px;
  padding: 0 20px 50px 20px;
`;
export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 26px;
  margin-right: 26px;
`;

export const Title = styled.h3`
  color: #122d58;
  font-weight: 700;
  font-size: ${(props) => props.fontSize || '14px'};
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  margin: 0;
`;

export const TitleRightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FootWrapper = styled.div`
  height: 6px;
  display: flex;
  /* flex-wrap: wrap; */
  flex-direction: column;
  flex: 1;
  align-content: flex-start;
  margin: 15px 0 35px 0;
`;
export const FootThick = styled.div`
  width: 25%;
  height: 6px;
  background: #122d58;
`;
export const FootLight = styled.div`
  height: 3px;
  width: 95%;
  background: #f4f4f4;
`;

export const WrapperContent = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;
